export default "__VITE_ASSET__CsP$GFa6__"